import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment.prod';
import { Customer } from '../api/customer';

@Injectable()
export class CustomerService {
    constructor(private http: HttpClient) {}

    private url = `${environment.apiUrl}`;

    createNewCustomer(customer: any): Observable<any> {
        const httpOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
        };
        var response = this.http.post(
            this.url + '/api/customer',
            customer,
            httpOptions
        );
        return response;
    }

    searchCustomer(searchText: String): Observable<any> {
        let params = new HttpParams();
        params = params.append('searchText', searchText.toString());
        return this.http.get<any>(`${this.url}/api/customer/search`, {
            params,
        });
    }

    fetchCustomerById(id: number): Observable<any> {
        return this.http.get<any>(`${this.url}/api/customer/${id}`);
    }

    fetchCustomerByNationalId(id: string): Observable<any> {
        return this.http.get<any>(
            `${this.url}/api/customer/find-by-nationalId?nationalId=${id}`
        );
    }
    fetchDependentsByCustomerId(customerId: number): Observable<any> {
        return this.http.get<any>(
            `${this.url}/api/customers/${customerId}/dependants`
        );
    }
    activateOrDeactivateDependant(
        customerId: number,
        dependantId: number,
        payload: {
            dependentId: any;
            firstName: any;
            lastName: any;
            gender: any;
            dob: any;
            nationalId: any;
            relationship: any;
            dependantStatus: string;
        }
    ): Observable<any> {
        return this.http.put(
            `${this.url}/api/customers/${customerId}/dependants/${dependantId}`,
            payload
        );
    }

    addCustomerVehicle(payload: any): Observable<any> {
        return this.http.post<any>(
            `${this.url}/api/vehicle`,
            payload
        );
    }

    fetchQuotes(customerId: number): Observable<any> {
        return this.http.get<any>(`${this.url}/api/sme/quote`, {
            params: new HttpParams().set('customerId', customerId.toString()),
        });
    }

    fetchAllCustomers(): Observable<Customer[]>{
        return this.http.get<Customer[]>(`${this.url}/api/customer/all-customers`);
    }
}
